import { render, staticRenderFns } from "./PeToolbar.vue?vue&type=template&id=4b4af0ba&"
import script from "./PeToolbar.vue?vue&type=script&lang=js&"
export * from "./PeToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports